import { LazyLoad } from 'app/utils';

export const EventListPage = LazyLoad(
  () => import('./index'),
  (module) => module.EventListPage,
);
